import { post, get } from 'src/tools/server';

const getSelectedProduct = (body) => {
  return post<any>(
    `/portal/discount/subscriptionBuy/selectedProducts`,
    body || {},
    {},
  );
};

export const getSubscriptionBuyList = (data) => {
  return post<any>(`/portal/discount/subscriptionBuy/list`, data || {}, {});
};

export const publishSubscription = (subscriptionBuyUuids) => {
  return post<any[]>(
    `/portal/discount/subscriptionBuy/publish`,
    { subscriptionBuyUuids },
    {},
  );
};

export const toDraftSubscription = (subscriptionBuyUuids) => {
  return post<any[]>(
    `/portal/discount/subscriptionBuy/toDraft`,
    { subscriptionBuyUuids },
    {},
  );
};

export const duplicateSubscription = (subscriptionBuyUuids) => {
  return post<any[]>(
    `/portal/discount/subscriptionBuy/duplicate`,
    { subscriptionBuyUuids },
    {},
  );
};

export const archiveSubscription = (subscriptionBuyUuids) => {
  return post<any[]>(
    `/portal/discount/subscriptionBuy/archive`,
    { subscriptionBuyUuids },
    {},
  );
};

const getSubscriptionBuy = (uuid, params?) => {
  return get<any>(`/portal/discount/subscriptionBuy/${uuid}`, params || {});
};

const postSubscriptionBuy = (body, params?) => {
  return post<any>(`/portal/discount/subscriptionBuy`, body, {
    returnWholeData: true,
    handleErrorAsResolve: true,
    ...(params || {}),
  });
};

const draftSubscriptionBuy = (body) => {
  return post<any>(`/portal/discount/subscriptionBuy/toDraft`, body, {});
};

const activeSubscriptionBuy = (body) => {
  return post<any>(`/portal/discount/subscriptionBuy/publish`, body, {});
};

const archiveSubscriptionBuy = (body) => {
  return post<any>(`/portal/discount/subscriptionBuy/archive`, body, {});
};

export {
  getSelectedProduct,
  getSubscriptionBuy,
  postSubscriptionBuy,
  draftSubscriptionBuy,
  activeSubscriptionBuy,
  archiveSubscriptionBuy,
};
